import {Basic} from '@packages/systems/core/plugins';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {iconName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';

const basicPlugin = Plugins.name('Basic');

const config = Atom.create({
  showEmpty: true,
  displayName: 'Heading 4',
  icon: {type: 'Component', value: [basicPlugin, iconName('H4')]},
  style: {
    base: {
      main: {
        noPseudo: {
          marginTop: px(0),
          marginBottom: px(0),
          paddingLeft: px(0),
          paddingRight: px(0),
        },
      },
    },
  },
  render: Atom.getConfigShape(Basic.atoms.Heading).render,
  dataType: Atom.getConfigShape(Basic.atoms.Heading).dataType,
});

export default config;
